import React from 'react';

import ActionButton from '../elements/ActionButton/ActionButton';
import { bgImageSet } from './bgImageSet';

import './ContactBanner.css';

const ContactBanner = ({
  title,
  description,
  bgImage,
  bgImageAvif,
  bgImageWebp,
  ctaStyle = 'coral',
  className = '',
}) => {
  const backgroundImage =
    bgImageAvif || bgImageWebp
      ? bgImageSet({ avif: bgImageAvif, webp: bgImageWebp, fallback: bgImage })
      : `url(${bgImage})`;

  return (
    <section className='contact-banner-section'>
      <div className={`contact-banner ${className}`.trim()} style={{ backgroundImage }}>
        <div className='contact-banner-content'>
          <h2>{title}</h2>
          <p>
            {description ||
              "We'd love to talk more about how our unique set of offerings can benefit your brand."}
          </p>
          <div className='contact-banner-btn-container'>
            <ActionButton
              to='/contact'
              text='Contact Us'
              className={ctaStyle === 'black' ? 'dark' : ''}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBanner;
